/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import NotificationStore, { Subscription } from 'stores/NotificationStore';
import DashboardStore from 'stores/DashboardStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import Loading from 'components/Loading/Loading';

import SentRequestPanel from './SentRequestPanel/SentRequestPanel';
import styles from './Notifications.module.scss';

type InjectedProps = {
  notificationStore: NotificationStore,
  dashboardStore: DashboardStore,
} & TranslatorProps;

@translate()
@inject('notificationStore', 'dashboardStore')
@observer
export default class SentRequests extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  @observable requestsSubscription: ?Subscription;

  componentDidMount() {
    const { notificationStore } = this.props;

    this.requestsSubscription = notificationStore.subscribeToNotifications(
      { type: 'sent-requests', urlParams: [], searchParams: [] },
      { background: false },
      true
    );
  }

  componentWillUnmount() {
    const { notificationStore } = this.props;

    if (this.requestsSubscription) {
      notificationStore.unsubscribeFromNotifications(this.requestsSubscription.id);
    }
  }

  renderRequest(sentRequest: Object) {
    return <SentRequestPanel key={sentRequest.id} sentRequest={sentRequest} />;
  }

  render() {
    const { t } = this.props;

    if (
      !this.requestsSubscription ||
      (!this.requestsSubscription.data.length && this.requestsSubscription.loading)
    ) {
      return <Loading />;
    }

    if (!this.requestsSubscription.data.length) {
      return (
        <p className={styles.noResults}>{t('general:notifications.no_results.sent_requests')}</p>
      );
    }

    return this.requestsSubscription.data.map(n => this.renderRequest(n));
  }
}
